import { ToastrService } from "ngx-toastr";
import { Title } from "@angular/platform-browser";
import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import {
  IgxDialogComponent,
  PositionSettings,
  slideInTop,
  slideOutBottom,
  HorizontalAlignment,
  VerticalAlignment,
} from "igniteui-angular";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { MenuUsersService } from "../../Services/menu-users.service";
import { MenuUsers } from "../../Model/menu-users";

@Component({
  selector: "menu-security-revisions",
  templateUrl: "./menu-security-revisions.component.html",
  styleUrls: ["./menu-security-revisions.component.css"],
})
export class MenuSecurityRevisionsComponent implements OnInit {
  private gridApi;
  private gridOptions;
  private crudAction;
  public menuUsers: MenuUsers[] = [];
  public menuSecurityRow;
  public showDialog = false;
  public showDialogCopy = false;
  public mode: string;
  public changeTrigger: number;

  @ViewChild("entryDialog", { static: true })
  public dialogEntry: IgxDialogComponent;
  @ViewChild("copyDialog", { static: true })
  public dialogCopy: IgxDialogComponent;

  constructor(
    private service: MenuUsersService,
    private toastr: ToastrService,
    private titleService: Title,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    // Get grid data
    this.titleService.setTitle("Menu Security");
    this.spinner.show();
    this.service.getAllGroupByUser().subscribe(
      (response) => {
        if (response.length > 0) {
          this.menuUsers = response;
          this.spinner.hide();
        } else {
          this.menuUsers = null;
          this.toastr.warning("No records found", "Warning");
          this.spinner.hide();
        }
      },
      (error) => {
        this.toastr.error("Unexpected error occurred", "Error");
        this.spinner.hide();
      }
    );
  }

  handleCreate() {
    this.mode = "Create";
    this.showDialog = true;
    this.changeTrigger += 1;
    this.dialogEntry.open();
  }

  handleCopy() {
    this.showDialogCopy = true;
    this.changeTrigger += 1;
    this.dialogCopy.open();
  }

  handleGridSelection(event) {
    // *Note* The event parameter (from dumb component) is an object
    // that contains the following:
    // rowSelected array
    // gridEvent
    this.gridOptions = event.gridEvent;
    // only open the window of row selected
    if (event.gridEvent.node.selected) {
      this.menuSecurityRow = event.gridEvent.node.data;
      this.showDialog = true;
      this.mode = "Update";
      this.changeTrigger += 1;
      this.dialogEntry.open();
    }

    // capture the event, so deselectall can be call when window closed
    this.gridOptions = event.gridEvent;
  }

  // showOrderScheduleOrderSummary(carrierName) {
  //   this.showOrderScheduleOrderSummaryWindow = true;
  //   this.cName = carrierName;
  //   this.dialogOrderScheduleOrderSummaryForm.open();
  // }

  handleClose() {
    this.dialogEntry.close();
    this.showDialog = false;
    this.ngOnInit();
  }

  handleCloseCopy() {
    this.dialogCopy.close();
    this.showDialogCopy = false;
    this.ngOnInit();
  }
}
